export default "__VITE_ASSET__CWaJhuZU__"